/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const MoveMoney = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        d="M22.6104 13.24L15.0004 7.7V10.79H7.51044V12.44L2.87044 9.06L7.50044 5.86V7.55H13.0104V6.05H9.00044V3L1.43044 8.23C1.17044 8.41 1.01044 8.71 1.00044 9.03C0.990443 9.35 1.15044 9.65 1.41044 9.84L9.02044 15.38V12.29H16.5104V10.64L21.1504 14.02L16.5204 17.22V15.53H11.0104V17.03H15.0204V20.08L22.6004 14.85C22.8604 14.67 23.0204 14.37 23.0304 14.05C23.0404 13.73 22.8804 13.43 22.6204 13.24H22.6104Z"
                        fill={color}
                    />
                </svg>
        );
    };
